import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { IProduct } from "shared/models/catalog.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";
import { Utilities } from "./utilities";

@Injectable()
export class CatalogData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private utilities: Utilities,
    private tracking: TrackingProvider,
  ) { }

  public createOrUpdateCatalog(clientId: string, catalog: IProduct, eventId: string) {
    if (catalog.id === "") {
      this.action = "create";
      catalog.id = this.afDb.createPushId();
    } else {
      this.action = "update";
    }

    let ref = `Clients/${clientId}/Interactivity/Product/${catalog.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Product/${catalog.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(ref)
        .update(catalog)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.product, catalog.id, clientId, eventId, catalog, "Creacion/actualizacion product");
        })
        // .then(() => {
        //   return this.historyData.set(
        //     `Catalog content`,
        //     "catalog",
        //     this.action,
        //     catalog,
        //   );
        // })
        .then(() => {
          resolve(catalog);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getCatalogByClientId(clientId: string, eventId: string): Observable<IProduct[]> {
    let ref = `Clients/${clientId}/Interactivity/Product`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Product`;
    }
    return this.afDb.list<IProduct>(ref).valueChanges();
  }

  public getCatalogActiveByClientId(clientId: string, eventId: string): Observable<IProduct[]> {
    let ref = `Clients/${clientId}/Interactivity/Product`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Product`;
    }
    return this.afDb.list<IProduct>(ref,
      (reference) => reference.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getCatalogById(clientId: string, catalogId: string, eventId: string): Observable<IProduct> {
    let ref = `Clients/${clientId}/Interactivity/Product/${catalogId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Product/${catalogId}`;
    }
    return this.afDb.object<IProduct>(ref).valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/catalog.ts